import { render, staticRenderFns } from "./ConfigConfirmation.vue?vue&type=template&id=4b683c92&"
import script from "./ConfigConfirmation.vue?vue&type=script&lang=js&"
export * from "./ConfigConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports